import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { breadcrumbSchema } from "@/lib/schema";
import { industries } from "@/content";
import { industryDetails } from "@/content/details";
import { DetailPage } from "@/components/detail-page";

const ROUTE = "/industries/health-dental";
export const Route = createFileRoute("/industries/health-dental")({
  head: () =>
    routeHead(ROUTE, {
      title: "Bookkeeping for Health and Dental Practices | NextEra",
      description:
        "Reliable bookkeeping, payroll and reporting for Australian health and dental practices.",
      jsonLd: breadcrumbSchema([
        { name: "Home", item: "/" },
        { name: "Industries", item: "/industries" },
        { name: "Health & Dental", item: ROUTE },
      ]),
    }),
  component: Page,
});
function Page() {
  const i = industries.find((x) => x.href === ROUTE)!;
  return (
    <DetailPage
      eyebrow="Industry"
      heading={i.name}
      description={i.summary}
      content={industryDetails[ROUTE]}
      related={industries
        .filter((x) => x.href !== ROUTE)
        .map((x) => ({ label: x.name, href: x.href }))}
    />
  );
}
